import classNames from "classnames";
import * as React from "react";
import { useMemo } from "react";
import { UnionAppEntity } from "~/normalizr/entities";
import { entityThumbnails } from "~/sharedComponents/thumbnails/consts";
import { EntityThumbnail } from "~/sharedComponents/thumbnails/EntityThumbnail";
import { Icon, IconNames, icon } from "../../icons";
import { inlinePopupSelectTheme } from "../InlinePopupSelect";
import * as styles from "./DefaultDropdownTrigger.less";
import { DefaultDropdownTriggerWrapper } from "./DefaultDropdownTriggerWrapper";
import { isInline } from "./utils";

export type DefaultDropdownTriggerProps = {
    text: string;
    theme?: inlinePopupSelectTheme;
    maxWidth?: number | string;
    showValidation?: boolean;
    showWarning?: boolean;
    leftIcon?: IconNames | JSX.Element;
    itemType?: UnionAppEntity;
    colorIcon?: string;
    showTriggerIcon?: boolean;
    isDisabled?: boolean;
    blockForFullStory?: boolean;
    tabIndex?: number;
    backgroundColor?: string;
    testId?: string;
    disabledReason?: string;
};

export const DEFAULT_DROPDOWN_TRIGGER_OPENED_CLASS = styles.open;

export const DefaultDropdownTrigger = React.forwardRef<HTMLDivElement, DefaultDropdownTriggerProps>((props, ref) => {
    const { text, theme, leftIcon, itemType, colorIcon, isDisabled, blockForFullStory, showTriggerIcon = true } = props;
    const showChevronIcon = useMemo(() => showTriggerIcon && !isInline(theme), [theme, showTriggerIcon]);

    return (
        <DefaultDropdownTriggerWrapper ref={ref} {...props}>
            <div className={classNames(styles.value_container, blockForFullStory ? "fs-block" : undefined)}>
                {itemType && <EntityThumbnail item={entityThumbnails[itemType]} />}
                {leftIcon &&
                    (typeof leftIcon === "string" ? (
                        <Icon iconName={leftIcon as IconNames} color={colorIcon} className={styles.select_left_icon} />
                    ) : (
                        leftIcon
                    ))}
                <span title={text} className={styles.value}>
                    {text}
                </span>
            </div>
            {showChevronIcon && (
                <Icon iconName={isDisabled ? icon.lock : icon.chevron_down_small} className={styles.chevron} />
            )}
        </DefaultDropdownTriggerWrapper>
    );
});
